/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){return"junction-edge-midspan-connectivity"===n.associationType}export{n as isConnectivityMidspan};
